import Toggle from "./Toggle"

export default function VerificationCard({ onToggle, isOn, isLoading }) {
  return (
    <div className="w-full max-w-lg rounded-2xl p-4 flex flex-col gap-6 bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-center justify-between">
        <span className="font-medium text-xl text-zi-text-light dark:text-zi-text-dark">
          تأیید دو مرحله‌ای
        </span>

        <Toggle onToggle={onToggle} isOn={isOn} isLoading={isLoading} />

      </div>
    </div>

  )
}
